module.exports = __webpack_public_path__ + "static/img/code2.97857ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/code2.png
// module id = jce3
// module chunks = 0